<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content d-flex flex-row" v-menu-permission="'list'">
            <DrawerHandler is-left class="col-lg-3 float-lg-left overflow-auto" style="height:750px" to-invisible>
            <!--EmFilterTree-->
            <em-filter-tree
                            filterEnable
                            :entity="modelName"
                            filterState="levelTreeFilter"
                            loadState="levelTreeNodes"
                            :selectedId="$_emLevelTreeListMixin_menuTreeSelectedId"
                            @onclick="$_emLevelTreeListMixin_menuTreeOnClick"></em-filter-tree>
            </DrawerHandler>
            <div class="float-lg-right col-lg-9">
                <div id="accordionFilter" class="content">
                    <div class="card">
                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                             data-parent="#accordionFilter">
                            <div class="card-body">
                                <form>
                                    <em-filter :entity="modelName" ref="emListFilter"
                                               @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="emEquipmentCategoryResultTable" class="content">
                    <div class="card my-1">
                        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                             data-parent="#accordionResult">
                            <div class="card-body">
                                <em-table :entity="modelName"
                                          ref="emTable"
                                          withCustomRowActions exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                          @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                          @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                    <template #customRowActions="{row}">
                                        <b-button-group>
                                            <em-button
                                                    v-if="$_emLevelTreeListMixin_getGrandParentId(row)"
                                                    type="gotoGrandParent"
                                                    v-bind:class="'btn btn-outline-primary btn-sm'"
                                                    @click="$_emLevelTreeListMixin_gotoGrandParentLevel(row)">
                                            </em-button>
                                            <em-button type="gotoChild"
                                                       v-bind:class="'btn btn-outline-primary btn-sm'"
                                                       @click="$_emLevelTreeListMixin_gotoChild(row)">
                                            </em-button>
                                        </b-button-group>
                                    </template>
                                </em-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"/>
    </div>
</template>
<script>
    // Author thq
    // Date 2022-04-21 21:31:47

    import emLevelTreeListMixin from "@/mixin/em/levelTree/list";
    import EmFilterTree from "@/components/em/EmFilterTree";
    import EmFilter from "@/components/em/EmFilter";
    import DrawerHandler from "@/components/echarts-part/CalendarShift/cells/stuffs/DrawerHandler";

    export default {
        name: "emEquipmentCategoryLevelTreeListView",
        mixins: [emLevelTreeListMixin],
        components: {DrawerHandler, EmFilter, EmFilterTree},
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        }
    }
</script>